import React,{useState} from "react";

import {
    Grid,
    IconButton,
    Box,
    Dialog,
    DialogTitle,
    Tooltip,
    DialogContent,
    Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AutorenewIcon from '@mui/icons-material/Autorenew';

import DescriptionIcon from '@mui/icons-material/Description';
import { GridToolbarContainer } from "@mui/x-data-grid-pro";
import { GridActionsCellItem, GridRowParams } from "@mui/x-data-grid-pro";

import {
    createStringDataField,
    createTimestampField,
    createStatusField,
    createStringDataFieldwithEllipis
} from "../../../../util/format";
import { StringEquators } from "../../../../store/constants/pages";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteConfirmation } from "../../../../common/GenericDeleteConfirmationDialog/DeleteConfirmationDialog";
import { XClientDataGrid,VanillaJSONEditor } from "../../../../common";
// import {VanillaJSONEditor}
export const ClientCreationStages = ({
    open,
    handleClose,
    isPending,
    data,
    reload,
    retry,
    name
}) => {
    const [defaultDialogState, setDefaultDialogState] = useState({
        open: false,
        rowData: null,
    });

    const isAnyFailedOrPendingStage = data?.some(
        stage => stage.status === "FAILED" || stage.status === "PENDING"
    );  
    
    function handleRefresh() {
        reload();
    }

    const handleArgumentsDataDisplay = (data,title,fullObj) => {
        setDefaultDialogState({ open: true, rowData: {json:data,title:`${title} (${fullObj?.stageName})`} });
        
    }

    const fields = [
        createStringDataField("stageName", "Name", {
            sortable: true,
            equators: StringEquators,
            width: 200,
        }),
        createStatusField("status", "Status", { returnWholeRow: true,width: 120 }),
        createStringDataFieldwithEllipis("errorMessage", "Error Description", {
            width: 250,
            wordBreak: "break-word",
            returnWholeRow: true,
            ellipisisWidth: 20,
            handleEllipisisShow: handleArgumentsDataDisplay,
        }),
        createStringDataFieldwithEllipis("metadata", "Meta Data", {
            width: 250,
            returnWholeRow: true,
            wordBreak: "break-word",
            ellipisisWidth: 20,
            handleEllipisisShow: handleArgumentsDataDisplay,
        }),

    ];

    return (
        <>
                   
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    maxHeight: "570px",
                },
            }}
            maxWidth="md"
        >
            <DialogTitle>
                <Grid container alignItems="center">
                    <Grid item xs={10}>
                        <Typography variant="h6">
                            Client Setup Stages - {name}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} className="text-right">
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            size="large"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <XClientDataGrid
                    fields={fields}
                    data={data || []}
                    // sortPtr={sortPtr}
                    loading={isPending}
                    hideFooter
                    slots={
                        {
                            toolbar: Toolbar,
                        } as any
                    }
                    slotProps={{
                        toolbar: {
                            handleRefresh, retry, isAnyFailedPending: isAnyFailedOrPendingStage                           
                        } as any,
                    }}
                />
            </DialogContent>
        </Dialog>
            <DeleteConfirmation
                customCancelBtnText="OK"
                DELETE_TEXT={``}
                customTitle={`${defaultDialogState?.rowData?.title}`}
                defaultSelected={[]}
                isConfirmationOnly={true}
                handleDelete={() =>
                    setDefaultDialogState({ open: false, rowData: null })
                }
                defaultDeleteState={defaultDialogState}
                hideDeleteBtn={true}
                handleClose={() =>
                    setDefaultDialogState({ open: false, rowData: null })
                }
            >
                <VanillaJSONEditor
                    content={{
                        json: defaultDialogState?.rowData?.json || [],
                    }}
                    readOnly={false}
                    navigationBar={false}
                    statusBar={false}
                    mainMenuBar={false}
                />
            </DeleteConfirmation>
            </>
    );
};

const Toolbar = ({ handleRefresh, retry, isAnyFailedPending }) => (
    <GridToolbarContainer>
        <Box sx={{ flexGrow: 1 }} />
        {isAnyFailedPending && 
            <Tooltip title="Retry Stages">
            <IconButton onClick={retry}>
                <AutorenewIcon />
            </IconButton>
        </Tooltip>
        }
        
        <IconButton onClick={handleRefresh}>
            <RefreshIcon />
        </IconButton>
    </GridToolbarContainer>
);
